import { ITagLeafBasicEvent } from '../../../../utils/apollo/graphqlSchema';
import { usePanelStateContext } from '../context';
import { assertCondition } from '../../../../utils/types';
import { isNil } from 'lodash';
import Loading from '../panel/Loading';
import { DescriptionIcon } from '../node/NodeIcon';
import {
  DescriptionBlock,
  DescriptionTerm,
  NodeDetailsMain,
  EntityTitle,
  NodeDetails,
  NodeDetailsHeader,
  NodeDetailsFooter,
} from '../EntitySelectionPanelUI';
import { isNotBlank } from '../utils';
import EntityCategoryDetails from './EntityCategoryDetails';
import NodeIsFavoriteIcon from '../node/NodeIsFavoriteIcon';
import NodeDetailsDescription from './NodeDetailsDescription';
import TableNames from './TableNames';

interface IProps {
  node: ITagLeafBasicEvent;
}

const BasicEventDetails = ({ node }: IProps) => {
  const { getEntityFromCache, entityLoading, selectNodeHandler } =
    usePanelStateContext();

  const selectedEntity = getEntityFromCache(node);
  if (entityLoading) {
    return <Loading />;
  } else if (!isNil(selectedEntity)) {
    assertCondition(selectedEntity.__typename === 'BasicEventValue');
    const eventValue = selectedEntity.value;
    const tableNames = selectedEntity.tableNames;
    return (
      <NodeDetails>
        <NodeDetailsHeader onClick={() => selectNodeHandler(node)}>
          <DescriptionIcon node={node} />
          <EntityTitle>{eventValue.name}</EntityTitle>
          {selectedEntity.isFavorite && <NodeIsFavoriteIcon />}
        </NodeDetailsHeader>
        <NodeDetailsMain>
          {isNotBlank(eventValue.description) && (
            <NodeDetailsDescription description={eventValue.description} />
          )}
          {tableNames.length > 0 && (
            <TableNames tableNames={tableNames.join(', ')} />
          )}
          {eventValue.isDisabled && (
            <DescriptionBlock>
              <DescriptionTerm>Disabled:</DescriptionTerm>
              Yes
            </DescriptionBlock>
          )}
        </NodeDetailsMain>
        <NodeDetailsFooter>
          {selectedEntity.categories?.length > 0 && (
            <EntityCategoryDetails
              entityCategories={selectedEntity.categories}
            />
          )}
        </NodeDetailsFooter>
      </NodeDetails>
    );
  }

  return null;
};
export default BasicEventDetails;
